import { render, staticRenderFns } from "./ResidentGroupList.vue?vue&type=template&id=3fc906a8&scoped=true&lang=pug"
import script from "./ResidentGroupList.vue?vue&type=script&lang=ts"
export * from "./ResidentGroupList.vue?vue&type=script&lang=ts"
import style0 from "./ResidentGroupList.vue?vue&type=style&index=0&id=3fc906a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc906a8",
  null
  
)

export default component.exports